import MobileHeader from "../../../layout/OwnerLayout/Header";
import { Box, Typography, useTheme } from "@mui/material";
import ArrowTickLeft from "../../../../media/images/icons/arrow-tick-left";
import Boxoutline from "../../../../media/images/icons/outline-box";
import CustomButton from "../../../components/CustomButton";
import { blueGrey, grey } from "@mui/material/colors";
import EyeSVG from "../../../../media/images/icons/eye";
import ArrowDownSVG from "../../../../media/images/icons/ArrowDownSVG";
import DriverInfoBox from "./DriverInfoBox";
import OrderStatus from "./OrderStatus";

export default function OrderDetailsPage() {
  const theme = useTheme();

  return (
    <>
      <MobileHeader title={HeadTitle()} hasScroll={false} />
      <Box
        sx={{
          flex: "1",
          paddingX: "8px",
          overflow: "auto",
        }}
      >
        <Box
          sx={{
            boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
            display: "flex",
            // border: "1px solid gray",
            borderColor: "info.main",
            borderStyle: "solid",
            gap: "4px",
            borderWidth: "1px",
            borderRadius: "16px",
            flexDirection: "column",
            padding: "8px",
            backgroundColor: "background.default",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "4px",
            }}
          >
            <Box
              sx={{
                backgroundColor: "info.light",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "6px",
                borderRadius: "8px",
              }}
            >
              <Boxoutline color={theme.palette.textColor.main} />
            </Box>
            <Box
              sx={{
                flex: "1",
                // border: "1px solid gray",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "start",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: "14px",
                  }}
                >
                  کنستانتره سنگ آهن فلان
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    // backgroundColor: "primary.light",
                    padding: "4px",
                    borderRadius: "8px",
                    gap: "4px",
                  }}
                >
                  {/* <BigCarIcon2 color={theme.palette.primary.main} /> */}
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: "700",
                    }}
                  >
                    شماره سفارش:{" "}
                  </Typography>
                  <Typography
                    sx={{
                      color: "primary.main",
                      fontSize: "14px",
                    }}
                  >
                    012345678910
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[400],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              کد رهگیری بارنامه:
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              29292955595559
            </Typography>
          </Box>

          <CustomButton
            rippleColor={theme.palette.info.dark}
            flex={1}
            justifyContent="center"
            // loading
            //   onClick={() => handleEditModal()}
            title="جزئیات سفارش"
            bgColor="primary.main"
            textColor="#fff"
            //   borderColor="success.dark"
            px="10px"
            py="12px"
            borderRadius="6px"
            icon1={<EyeSVG size={22} color={"#fff"} />}
          />

          <Box
            sx={{
              marginTop: "8px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <CustomButton
              rippleColor={theme.palette.info.dark}
              flex={1}
              justifyContent="center"
              // loading
              //   onClick={() => handleEditModal()}
              title="دانلود گزارشات"
              bgColor={blueGrey[50]}
              textColor={grey[800]}
              borderColor={blueGrey[100]}
              px="10px"
              py="12px"
              borderRadius="6px"
              icon1={<EyeSVG size={22} color={grey[800]} />}
            />
            <CustomButton
              rippleColor={theme.palette.info.dark}
              flex={1}
              justifyContent="center"
              // loading
              //   onClick={() => handleEditModal()}
              title="جزئیات سفارش"
              bgColor={blueGrey[50]}
              textColor={grey[800]}
              borderColor={blueGrey[100]}
              px="10px"
              py="12px"
              borderRadius="6px"
              icon1={<ArrowDownSVG size={22} color={grey[800]} />}
            />
          </Box>
        </Box>

        <DriverInfoBox />
        <OrderStatus />
      </Box>
    </>
  );
}

function HeadTitle() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          color: "secondary.main",
          fontWeight: 700,
          fontSize: "14px",
        }}
      >
        مدیریت بارها{" "}
      </Typography>
      <ArrowTickLeft size={14} color={theme.palette.info.dark} />
      <Typography
        sx={{
          color: "secondary.main",

          fontSize: "14px",
          fontWeight: 700,
        }}
      >
        جزئیات سفارش{" "}
      </Typography>
    </Box>
  );
}
